<template>
    <section class="spot-programs" v-scrollee="{ offset: 200, once: true }" @scrollee="handle">
        <section-title>PROGRAM</section-title>
        <p class="program__text">아래는 <b>'{{spot.name}}'</b>에서 진행되는<br>오늘은 경리단 프로그램입니다.</p>
        <p class="program__caption">* 예약은 프로그램 상세 페이지에서 가능합니다.</p>
        <div class="programs">
            <program-card v-for="program in spot.programs" :key="program.id" ref="cards"
                          :program="program"/>
        </div>
    </section>
</template>

<script>
import anime from 'animejs'
import ProgramCard from '@/components/ProgramCard'

export default {
    name: 'SpotPrograms',
    components: {
        ProgramCard,
    },
    props: {
        spot: null
    },
    data() {
        return {
            active: false
        }
    },
    methods: {
        handle() {
            this.active = true
            this.$refs.cards.forEach((x, index) => {
                const delay = index * 75
                anime({
                    targets: x.$el,
                    translateY: {
                        value: ['10%', 0],
                        duration: 750,
                    },
                    opacity: {
                        value: [0, 1],
                        easing: 'easeOutQuint',
                        duration: 350
                    },
                    delay
                })
            })
        },
        async listEnter(el, done) {
            const delay = el.dataset.index * 75
            await anime({
                targets: el,
                translateY: {
                    value: ['10%', 0],
                    duration: 750,
                },
                opacity: {
                    value: [0, 1],
                    easing: 'easeOutQuint',
                    duration: 350
                },
                delay,
            }).finished
            done()
        }
    },
}
</script>

<style scoped lang="scss">
@import '~@/styles/_parts';

.program__text {
    line-height: em(24);
    margin-top: em(38);
    text-align: center;
}
.program__caption {
    font-size: em(12);
    line-height: em(20, 12);
    margin-top: em(14, 12);
    text-align: center;
}
.programs {
    margin-top: em(38);
}
.program-card {
    margin-bottom: 1em;
    opacity: 0;
}
</style>